import {
    FETCH_FORGET_SUCCESS,
    FETCH_LOGIN_SUCCESS,
    FETCH_CODE_SUCCESS,
    FETCH_NEWPASS_SUCCESS
} from "../type";

import axios from "axios";
import { API_ENDPOINT } from '../../../AppConfig';
import { hideLoading,showLoading } from 'react-redux-loading-bar';
import { showSnack } from 'react-redux-snackbar';

export function SendingEmail(data, lang) {

    return (dispatch, getState) => {
        let uri = `${API_ENDPOINT}/forgetPassword`;
        dispatch(showLoading());
        axios.post(uri, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(response => {
                console.log("SENDEMAIL res",response.data)
                saveToLocalStorage('sendEmail', JSON.stringify(data));
                dispatch({ type: FETCH_FORGET_SUCCESS, payload: 'code' });
                dispatch(hideLoading());
            }).catch(error => {
                // console.log("SENDEMAIL err", error.response)
                dispatch(hideLoading());
                if (!error.response) {
                    dispatch(showSnack('myUniqueId', {
                        label: lang === 'en' ? 'Network Error' : 'خطأ فى الاتصال بالانترنت',
                        timeout: 7000,
                        button: { label: lang === 'en' ? 'E-mail': ' البريد الالكترونى' }
                    }));
                }
                else if (error.response.status === 404) {
                    dispatch(showSnack('myUniqueId', {
                        label: lang === 'en' ? 'This email does not exsit' : 'البريد الالكترونى غير موجود',
                        timeout: 7000,
                        button: { label: lang === 'en' ? 'E-mail': ' البريد الالكترونى' }
                    }));
                }
            })
    }
}

export function ResetPass(data, lang) {
    return (dispatch, getState) => {
        let uri = `${API_ENDPOINT}/confirmationchange`;
        dispatch(showLoading());

        axios.put(uri, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(response => {
                console.log("RESETPASS res", response.data);
                saveToLocalStorage('Korasatoken', JSON.stringify(response.data.token));
                saveToLocalStorage('KorasaAppuser',  JSON.stringify(response.data.user));
                // dispatch({ type: FETCH_FORGET_SUCCESS, payload: 'dashboard' });
                dispatch({ type: FETCH_NEWPASS_SUCCESS, payload: response.data });
                dispatch(hideLoading());

            }).catch(error => {
                console.log("RESETPASS err", error.response);
                dispatch(hideLoading());
                if (!error.response) {
                    dispatch(showSnack('myUniqueId', {
                        label: lang === 'en' ? 'Network Error' : 'خطأ فى الاتصال بالانترنت',
                        timeout: 7000,
                        button: { label: lang === 'en' ? 'Reset password' : ' كلمة المرور الجديدة' }
                    }));
                }
            })
    }
}
 export function ResetMail (data, lang) {
    return (dispatch, getState) => {
        let uri = `${API_ENDPOINT}/confirmationCode`;
        dispatch(showLoading());

        axios.put(uri, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(response => {
                // console.log("RESETPASS res", response.data);
                saveToLocalStorage('Korasatoken', JSON.stringify(response.data.token));
                saveToLocalStorage('KorasaAppuser',  JSON.stringify(response.data.user));
                // dispatch({ type: FETCH_FORGET_SUCCESS, payload: 'dashboard' });
                dispatch({ type: FETCH_CODE_SUCCESS, payload: 'resetPassword' });
                dispatch(hideLoading());

            }).catch(error => {
                console.log("RESETPASS err", error.response);
                dispatch(hideLoading());
                if (!error.response) {
                    dispatch(showSnack('myUniqueId', {
                        label: lang === 'en' ? 'Network Error' : 'خطأ فى الاتصال بالانترنت',
                        timeout: 7000,
                        button: { label: lang === 'en' ? 'Reset password' : ' كلمة المرور الجديدة' }
                    }));
                }
            })
    }
}
export function saveToLocalStorage(key, value) {
    localStorage.setItem(key, value);
}
